import { HOST } from '../config';
import { apiGet, apiPost } from '../api';
import { fetchGetAccountInfo } from './auth';

export const A = {
  FETCH_SUMMARY_SUCCESS: `FETCH_SUMMARY_SUCCESS`,

  // REQUEST_RECALCULATE_PRODUCT_MARGIN: 'REQUEST_RECALCULATE_PRODUCT_MARGIN',
  RECEIVE_RECALCULATE_PRODUCT_MARGIN_DELIVERED: 'RECEIVE_RECALCULATE_PRODUCT_MARGIN_DELIVERED',
  RECEIVE_RECALCULATE_PRODUCT_MARGIN_SHIPPED: 'RECEIVE_RECALCULATE_PRODUCT_MARGIN_SHIPPED',
  // ERROR_RECALCULATE_PRODUCT_MARGIN: 'ERROR_RECALCULATE_PRODUCT_MARGIN',
};

const fetchSummarySuccess = (response) => ({
  type: A.FETCH_SUMMARY_SUCCESS,
  summary: response,
});

const fetchSummaryFailure = (err) => ({
  type: A.FETCH_SUMMARY_SUCCESS,
  summary: err,
});

export const fetchSummary = () => (dispatch, getState) => {
  let url = `${HOST}/api/lite/reports${getState().auth.account.reportsUseDemoData ? `/demo` : ``}`;

  return new Promise((resolve, reject) => {
    apiGet({
      url,
      tokens: getState().auth.tokenData,
      callback: (res) => {
        if (res) {
          dispatch(fetchSummarySuccess(res));
          resolve(res);
        }
      },
      error: (err) => {
        dispatch(fetchSummaryFailure(err));
        reject(err);
      },
    });
  });
};

export const fetchChangeUsedData = (value) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    apiPost({
      url: HOST + '/api/lite/account_info/reports_demodata',
      tokens: getState().auth.tokenData,
      body: { value },
      callback: (res) => {
        if (res.success) {
          resolve();
          return dispatch(fetchGetAccountInfo());
        } else {
          reject();
        }
      },
      error: () => {
        reject();
      },
    });
  });
};

export const fetchRecalculateProductMargin = (isDelivered) => {
  return (dispatch, getState) => {
    // dispatch(requestRecalculateProductMargin());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + `/api/lite/report/margin?isDelivered=${isDelivered}`,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (isDelivered && res.date) {
            dispatch(receiveRecalculateProductMarginDelivered(res)); //*** Доставленные
            resolve(res);
          } else if (!isDelivered && res.date) {
            dispatch(receiveRecalculateProductMarginShipped(res)); //*** Отгруженные
            resolve(res);
          } else {
            // const err = { data: { errors: res.errors } };
            // dispatch(errorRecalculateProductMargin(err));
            // reject(err);
          }
        },
        error: (err) => {
          // dispatch(errorRecalculateProductMargin(err));
          // reject(err);
        },
      });
    });
  };
};

// const requestRecalculateProductMargin = () => {
//   return {
//     type: A.REQUEST_RECALCULATE_PRODUCT_MARGIN,
//   };
// };

const receiveRecalculateProductMarginDelivered = (data) => {
  return {
    type: A.RECEIVE_RECALCULATE_PRODUCT_MARGIN_DELIVERED,
    data,
  };
};

const receiveRecalculateProductMarginShipped = (data) => {
  return {
    type: A.RECEIVE_RECALCULATE_PRODUCT_MARGIN_SHIPPED,
    data,
  };
};

// const errorRecalculateProductMargin = (err) => {
//   return {
//     type: A.ERROR_RECALCULATE_PRODUCT_MARGIN,
//     err,
//   };
// };
